import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: var(--color-black);
  color: var(--color-white);
  padding: 40px 20px;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 15px;
  min-width: 200px;
`;

const FooterTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--color-white);
`;

const FooterLink = styled.a`
  color: var(--color-gray);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: var(--color-blue);
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

const SocialLink = styled.a`
  color: var(--color-gray);
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: var(--color-blue);
  }
`;

const Copyright = styled.div`
  width: 100%;
  text-align: center;
  padding: 30px 20px 0 20px;
  border-top: 1px solid #333;
  color: var(--color-gray);
  font-size: 0.9rem;
  margin-top: 40px;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Support</FooterTitle>
          <FooterLink href="/help">Help</FooterLink>
          <FooterLink href="/about">About Us</FooterLink>
          <FooterLink href="/privacy">Privacy Policy</FooterLink>
          <FooterLink href="/terms">Terms of Service</FooterLink>
          <FooterLink href="/help#contact">Contact Us</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Follow Us</FooterTitle>
          <SocialLinks>
            <SocialLink href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</SocialLink>
          </SocialLinks>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        © 2025 Acronyx Technologies. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
